import { mutatorAction } from 'satcheljs';
import { CommandingViewMode } from 'owa-outlook-service-option-store/src/store/schema/options/CommandingOptions';
import { getStore } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { OwsOptionsFeatureType } from 'owa-outlook-service-options';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { saveCommandingViewModeOption } from 'owa-commanding-option';

/**
 * This function gets the default CommandingViewMode to render with
 * at boot. The value will either be from OWS' settings or the default values (in
 * the case where the user hasn't modified this preference yet, or the service
 * returns an unknown value).
 *
 * Note that we're getting these values from the UserConfiguration object instead
 * of from the "owa-outlook-service-options" package for boot bundle size health.
 */
const getDefaultCommandingViewModeOnBoot = (primeBootSettingsOptions: any[]) => {
    const primeCommandingOptions: any[] = primeBootSettingsOptions.filter(
        item => item?.feature == OwsOptionsFeatureType.Commanding
    );

    // viewMode can be const when mon-ribbon-mail and mon-ribbon-mail-multiline flights are removed
    let viewMode = primeCommandingOptions[0]?.viewMode;

    // Validate OWS' response value. Downgrade if flights have been turned off.
    if (!viewMode) {
        return undefined;
    }

    if (
        viewMode === CommandingViewMode.MultiLineRibbon &&
        !isFeatureEnabled('mon-ribbon-mail-multiline')
    ) {
        viewMode = CommandingViewMode.SingleLineRibbon;
    }

    if (viewMode === CommandingViewMode.SingleLineRibbon && !isFeatureEnabled('mon-ribbon-mail')) {
        viewMode = CommandingViewMode.CommandBar;
    }

    return viewMode as CommandingViewMode;
};

/**
 * Initializes owa-command-ribbon-store's viewMode using either OWS'
 * settings or the default values.
 */
export const initializeCommandingViewMode = mutatorAction(
    'initializeCommandingViewMode',
    (primeBootSettingsOptions: any[]) => {
        let viewMode = getDefaultCommandingViewModeOnBoot(primeBootSettingsOptions);

        if (!viewMode) {
            // Received no viewMode option, or fell back to default.
            if (!isFeatureEnabled('mon-ribbon-mail')) {
                viewMode = CommandingViewMode.CommandBar;
            } else {
                viewMode = isHostAppFeatureEnabled('ribbonDefaultToSLR')
                    ? CommandingViewMode.SingleLineRibbon
                    : CommandingViewMode.CommandBar;

                if (isHostAppFeatureEnabled('ribbonPersistDefault')) {
                    saveCommandingViewModeOption(viewMode);
                }
            }
        }

        getStore().viewMode = viewMode;
    }
);
